import React, {useState} from 'react';
import {message, Modal, Upload, UploadFile} from "antd";
import ImgClose from "@/shared/pictures/close.svg";
import {useStore} from "@/app/providers/StoreProvider";
import {ModalPayload} from "@/entities/modals/types";
import ImgTeamBorder from "@/shared/pictures/pucks_team.png";
import {IQuestItemType} from "@/entities/quest/types";


export const QuestCheckModal = (payload: ModalPayload<"questCheck">) => {
    const { modalStore, questsStore, errorStore } = useStore();

    const [fileList, setFileList] = useState<UploadFile[]>([]);

    const handleChange = (info: { file: UploadFile; fileList: UploadFile[] }) => {
        const updated = info.fileList.map(file => {
            if (!file.preview && file.originFileObj) {
                file.preview = URL.createObjectURL(file.originFileObj);
            }
            return file;
        });
        setFileList(updated);
    };

    const maxSize = 10 * 1024 * 1024;
    const allowedTypes = [
        'image/jpeg',
        'image/png'
    ];

    const beforeUpload = async(file: File) => {
        if (!allowedTypes.includes(file.type)) {
            message.error('Формат изображения не поддерживается');
            return Upload.LIST_IGNORE;
        }
        if (file.size > maxSize) {
            message.error('Превышен размер изображения');
            return Upload.LIST_IGNORE;
        }
        return file;
    };


    const handleUpload = async () => {
        if ((!fileList.length || !fileList[0].originFileObj) ) {
            message.error('Загрузите подтверждение');
            return;
        }

        const file = fileList[0].originFileObj;
        const formData = new FormData();
        formData.append('file', file);

    };

    const sendCheck = async () => {
        await questsStore.checkQuests({questNameEnum:payload.id,secret:''});
        await questsStore.getQuests();
        modalStore.open('questCompleted',{});
    }

    return (
        <Modal
            open={true}
            footer={null}
            closeIcon={<img src={ImgClose} onClick={() => modalStore.close()} alt=""/>}
        >
            <div className='modal'>

                <h3 className='modal_title'>{payload.item.conditionText}</h3>
                <p className='modal_text'>{payload.item.giftText}</p>

                <Upload
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                    fileList={fileList}
                    maxCount={1}
                >
                    <div className="teamcreate_file-button" >Прикрепить скриншот</div>
                </Upload>
                {fileList.length > 0?
                    fileList.map(file => (
                        <div key={file.uid}>
                            <img className='modal_image' src={file.preview} alt={file.name} key={file.uid} style={{maxWidth: 100, margin: 0}}/>
                        </div>
                    ))
                    :null
                }

                <div className='modal_buttons'>
                    <button type='button' className='modal_button button_blue' onClick={() => sendCheck()}>Отправить</button>
                    <button type='button' className='modal_button button_gray'
                            onClick={() => modalStore.close()}>Закрыть
                    </button>
                </div>

            </div>
        </Modal>
    );
};

